import { h, render } from 'preact';
import { initFrameAndPoll } from '@newswire/frames';

import data from '../../../data/data.json';
import PartyBarChart from '../components/PartyBarChart';

const partiesData = data['parties'];
const statewideMax = 15000000;

render(
  <div id="party-charts-container" class="three-column">
    <PartyBarChart
      yearData={partiesData.find(d => d.year === 2018)}
      statewideMax={statewideMax}
    />
    <PartyBarChart
      yearData={partiesData.find(d => d.year === 2022)}
      statewideMax={statewideMax}
    />
    <PartyBarChart
      yearData={partiesData.find(d => d.year === 2026)}
      statewideMax={statewideMax}
    />
  </div>,
  document.getElementById('party-comparison')
);

initFrameAndPoll(200);

if (process.env.NODE_ENV === 'development') {
  require('preact/debug');
}
